///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import ChevronLeft from "./ChevronLeft";
import ChevronRight from "./ChevronRight";

const Button = styled.button`
  outline: none;
  text-decoration: none;
  border: none;
  text-transform: uppercase;
  display: block;
  position: absolute;
  background: transparent;
  ${(props) => {
    if (props.left) {
      return "left: 25px;";
    } else {
      return props.vertical ? "right: 25px; top: 278px;" : "right: 25px;";
    }
  }}
  padding: 4px;
  margin-top: -3px;
  width: 14px;
  svg {
    display: block;
  }
`;

const NavButton = ({ onClick, left, ...rest }) => {
  return (
    <Button type="button" onClick={onClick} left={left} {...rest}>
      {left ? <ChevronLeft color="#000" /> : <ChevronRight color="#000" />}
    </Button>
  );
};

export default NavButton;
